var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInputHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85511 7.23684L12.5568 9.73158V9.60526C12.5568 8.97712 12.2874 8.3747 11.8079 7.93054C11.3284 7.48637 10.6781 7.23684 10 7.23684H9.85511ZM6.19034 7.86842L7.51136 9.09211C7.46875 9.2579 7.44318 9.42368 7.44318 9.60526C7.44318 10.2334 7.71256 10.8358 8.19206 11.28C8.67155 11.7242 9.32189 11.9737 10 11.9737C10.1875 11.9737 10.375 11.95 10.554 11.9105L11.875 13.1342C11.304 13.3947 10.6733 13.5526 10 13.5526C8.86982 13.5526 7.78592 13.1367 6.98676 12.3965C6.1876 11.6562 5.73864 10.6522 5.73864 9.60526C5.73864 8.98158 5.90909 8.39737 6.19034 7.86842ZM1.47727 3.50263L3.42045 5.30263L3.80398 5.65789C2.39773 6.68421 1.28977 8.02632 0.625 9.60526C2.09943 13.0711 5.73864 15.5263 10 15.5263C11.321 15.5263 12.5824 15.2895 13.733 14.8632L14.0994 15.1947L16.5881 17.5L17.6705 16.4974L2.55966 2.5M10 5.65789C11.1302 5.65789 12.2141 6.07378 13.0132 6.81405C13.8124 7.55433 14.2614 8.55836 14.2614 9.60526C14.2614 10.1105 14.1506 10.6 13.9545 11.0421L16.4517 13.3553C17.7301 12.3684 18.7528 11.0737 19.375 9.60526C17.9006 6.13947 14.2614 3.68421 10 3.68421C8.80682 3.68421 7.66477 3.88158 6.59091 4.23684L8.44034 5.93421C8.92614 5.76053 9.44602 5.65789 10 5.65789Z",
    fill: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInputHide);
export default __webpack_public_path__ + "static/media/icn_input_hide.ed1ce0625332542f5011475d9ab07f77.svg";
export { ForwardRef as ReactComponent };